export const getLayoutPreviewData = (custom_layout = {}, text = {}) => {
  return {
    sidebar_image: custom_layout.sidebar_image || 'https://cdn.upshow.tv/assets/spotlight_creator/custom_layout_sidebar.jpg',
    main_image: custom_layout.main_image || 'https://cdn.upshow.tv/assets/spotlight_creator/custom_layout_main.jpg',
    footer_text: custom_layout.footer_text || 'Footer Text Goes Here',
    footer_text_color: custom_layout.footer_text_color || text.title_color,
    footer_font: custom_layout.footer_font || text.title_font_family
  };
};